import { CalendarClock, Send } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { InviteSlot } from "@/lib/onboarding/slots";
import { Tag } from "@/components/ui/tag";
import { SegmentedControl } from "@/components/ui/segmented-control";

interface ScheduleChooserProps {
  when: "now" | "later";
  onWhenChange: (when: "now" | "later") => void;
  slots: InviteSlot[];
  scheduledAt: string | null;
  onScheduledAtChange: (iso: string) => void;
}

/** "Skicka direkt" or one of the next weekday slots. */
export function ScheduleChooser({ when, onWhenChange, slots, scheduledAt, onScheduledAtChange }: ScheduleChooserProps) {
  const { t } = useTranslation("onboarding");
  return (
    <div className="flex flex-col gap-3">
      <span className="text-[13px] font-semibold text-g-ink-700">{t("invite.when.label")}</span>
      <SegmentedControl
        aria-label={t("invite.when.label")}
        value={when}
        onChange={onWhenChange}
        options={[
          { value: "now", label: t("invite.when.now"), icon: <Send className="h-4 w-4" aria-hidden="true" /> },
          { value: "later", label: t("invite.when.later"), icon: <CalendarClock className="h-4 w-4" aria-hidden="true" /> },
        ]}
      />
      {when === "later" ? (
        <div role="radiogroup" aria-label={t("invite.slots.label")} className="flex flex-wrap gap-2">
          {slots.length === 0 ? (
            <span className="text-[13px] text-g-ink-500">{t("invite.slots.none")}</span>
          ) : (
            slots.map((slot) => (
              <Tag key={slot.iso} selected={scheduledAt === slot.iso} onSelect={() => onScheduledAtChange(slot.iso)}>
                {slot.label}
              </Tag>
            ))
          )}
        </div>
      ) : null}
    </div>
  );
}
